// extracted by mini-css-extract-plugin
export default {"alertBanner":"@gscope-mfe-common-components__src-components-AlertBanner-___AlertBanner-module__alertBanner___wX520"};